import { render, staticRenderFns } from "./InternalToolbar.vue?vue&type=template&id=bc4aa4dc"
import script from "./InternalToolbar.vue?vue&type=script&lang=js"
export * from "./InternalToolbar.vue?vue&type=script&lang=js"
import style0 from "./InternalToolbar.vue?vue&type=style&index=0&id=bc4aa4dc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports